// 這個清單刻意跟 router/index.js 的 route path 保持一致（不含開頭的 /）。
// getBasePath() 靠「目前網址的最後一段是不是這裡面的路由名稱」來判斷部署資料夾前綴在哪裡結束，
// 所以新增路由時記得同步更新這裡，不然新路由會被誤判成資料夾名稱的一部分。
const KNOWN_ROUTE_SEGMENTS = [
  'mobile', 'illustration', 'ar', 'mappage', 'qa',
  'mangogame', 'chinaberrygame', 'soapberrygame', 'soapberrybracelet', 'handlandmarkdebug'
]

// 部署資料夾前綴不再是 build 時寫死的字串（原本讀 process.env.BASE_URL，
// 但 vue.config.js 的 publicPath 已改成 'auto'，這個值在執行期不可靠)，
// 改成執行時從目前網址動態算出來，這樣同一份 build 產物丟到任何名稱／深度的資料夾都能正常運作。
// 例如目前網址是 https://host/custommap/ar?point=x，算出來就是 '/custommap/'；
// 部署在網域根目錄、網址是 https://host/ar?point=x，算出來就是 '/'。
export function getBasePath() {
  const segments = window.location.pathname.split('/').filter(Boolean)
  if (segments.length && KNOWN_ROUTE_SEGMENTS.includes(segments[segments.length - 1].toLowerCase())) {
    segments.pop()
  }
  return segments.length ? `/${segments.join('/')}/` : '/'
}

// 將 public/ 目錄下的根相對路徑（例如 '/assets/models/x.glb'）補上部署路徑前綴
export function withBase(path) {
  if (!path) return path
  if (/^https?:\/\//.test(path)) return path
  const base = getBasePath()
  const baseNoTrailingSlash = base.endsWith('/') ? base.slice(0, -1) : base
  const rel = path.startsWith('/') ? path : `/${path}`
  return baseNoTrailingSlash + rel
}
